module.exports = __webpack_public_path__ + "static/atlas-shrugged-c1022f5a0977ea5b7afc5b8496135a74.jpg";